/*
 * @Author: huangzq
 * @Date: 2020-04-13 20:07:37
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 14:54:30
 * @Desc: 课程编辑or新建
*/
<template>
  <mba-edit-base-layout
    v-loading="loading"
    :config="layout"
    :with-footer="false"
    class="inside-course-create-edit"
  >
    <template slot="content">
      <ds-form
        ref="courseForm"
        :rules="formRules"
        :global-config="formGlobalConfig"
        :form-schema="formSchema"
        @change="handelOnFormChange"
      ></ds-form>
    </template>

    <template slot="footer">
      <mk-button-biz
        type="primary"
        :loading="confirmBtnLoading"
        @click="checkForm('onComfirm')"
      >
        发布课程
      </mk-button-biz>
    </template>
  </mba-edit-base-layout>
</template>

<script>
import { MBASVCAPIS } from '@api'

import DsForm from '../components/ds-form'
import { FormGlobalConfig, FormRules, FormSchema } from './components/form-config'

import MbaEditBaseLayout from '../components/mba-edit-base-layout'

export default {
  name: 'InsideCourseCreateEdit',
  components: { MbaEditBaseLayout, DsForm },
  data () {
    return {
      // 布局配置
      layout: {
        header: {
          title: '新建课程',
          backTxt: '该课程还未发布，确认返回吗？',
          needBackTxt: false
        }
      },
      // 0:新建，1:编辑，根据地址上面是否有id来判断的
      pageStatus: 0,
      // 其他接口promise：新建、更新、查询等
      api: {
        create: MBASVCAPIS.CourseApi.courseCreatePost,
        update: MBASVCAPIS.CourseApi.courseUpdatePut,
        find: MBASVCAPIS.CourseClientApi.courseSystemCourseDetailGet
      },

      // 页面加载中
      loading: true,

      // 详情id
      detailId: '',
      // 表单数据
      formData: {},

      // 表单全局配置：作用在 el-form 上的
      formGlobalConfig: FormGlobalConfig,
      // 表单规则
      formRules: FormRules,
      // 表单配置：每一项表单item生成所依据的数据
      formSchema: FormSchema,

      // 确认按钮loading
      confirmBtnLoading: false
    }
  },
  created () {
    this.detailId = this.$route.query.id
    this.pageStatus = this.detailId ? 1 : 0
    if (this.pageStatus) {
      this.layout.header.title = '课程详情'

      this.getFormDataByApi()
    } else {
      this.layout.header.title = '新建课程'

      this.initFormData()
    }
  },
  methods: {
    // 初始化表单数据
    async initFormData (data = null) {
      let formData = {}
      if (data) {
        formData = this._.cloneDeep(data)

        // 过滤掉-禁用的标签
        formData.tags = formData.showTags.map(item => {
          return item.id
        })
      } else {
        formData = {
          // 课程名
          name: '',
          // 课程标签ID
          tags: [],
          // 课程状态 1=启用， 2=停用 默认为启用
          status: 1,
          // 描述
          description: '',
          // 课件列表
          courseWares: [ ]

        }
      }

      // 处理formSchema里面的value值
      this.handleFormSchema(formData)

      this.formData = formData

      this.$nextTick(() => {
        this.loading = false
      })
    },

    // 处理formSchema里面的value值
    handleFormSchema (data) {
      for (const key in this.formSchema) {
        if (this.formSchema.hasOwnProperty(key)) {
          const element = this.formSchema[key]
          element.value = data[key]
          element.defaultValue = data[key]
        }
      }
    },

    // 通过接口获取数据，当存在_id时，才执行
    async getFormDataByApi () {
      const res = await this.api.find({ _id: this.detailId })
      if (res.success) {
        this.initFormData(res.data)
      } else {
      }
    },

    // 表单change事件
    handelOnFormChange () {
      this.layout.header.needBackTxt = true
    },

    // 验证表单必填
    checkForm (methods) {
      this.$refs.courseForm.$refs.dsFormBiz.validate(valid => {
        if (valid) {
          const params = this.$refs.courseForm.getParams()
          this.formData = Object.assign({}, this.formData, params)
          this.formData.name = this.formData.name.trim()

          if (this.formData.name === '') {
            this.$message.error('课程名称不能为空')
            return
          }

          if (this.formData.courseWares.length === 0) {
            this.$message.error('请添加至少一项课件内容')
            return
          }

          this[methods]()
        }
      })
    },

    // 确认事件
    async onComfirm () {
      this.confirmBtnLoading = true
      const confirmApi = this.pageStatus ? this.api.update : this.api.create
      const res = await confirmApi(this.formData)
      if (res.success) {
        this.confirmBtnLoading = false
        this.$message.success('发布成功')
        this.$router.go(-1)
      } else {
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.inside-course-create-edit {
  .ds-form-biz {
    margin: 10px 36px;
  }
}
</style>
